export const conditionsReducerKey = 'conditionsReducer';

export const CONDITIONS_PAGE_TITLE = 'Reaction Conditions Navigator';
export const CONDITIONS_DRAW_PAGE_TITLE = 'Draw a target molecule or Insert structure from its name for conditions navigator';
export const CONDITIONS_PAGE_SIZE = 15;
export const CONDITIONS_DEFAULT_SORT = [{ property: 'date', direction: 'DESC' }];
export const CONDITIONS_DEFAULT_TOTAL_PAGES = 1;
export const CONDITIONS_RESULTS_BREADCRUMB_COMMENT = 'Conditions Navigator';
export const CONDITIONS_RESULTS_BREADCRUMB_HISTORY_TYPE = 'conditionsNavigator';
export const CONDITIONS_RESULTS_BREADCRUMB_PARAMS = {
  breadcrumbComment: CONDITIONS_RESULTS_BREADCRUMB_COMMENT,
  breadcrumbHistoryType: CONDITIONS_RESULTS_BREADCRUMB_HISTORY_TYPE,
};
export const CONDITIONS_RESULTS_BREADCRUMB_STATE = {
  comment: CONDITIONS_RESULTS_BREADCRUMB_COMMENT,
  historyType: CONDITIONS_RESULTS_BREADCRUMB_HISTORY_TYPE,
};
// Copy for the draw page "Learn how it works" panel. Rendered in the order declared here.
export const CONDITIONS_LEARN_HOW_IT_WORKS_STEPS = [
  'Draw your target reaction.',
  'Reaxys finds similar published reactions.',
  'Review the summarised reaction conditions and supporting evidence.',
  'Explore functional group behavior and related reactions.',
];

export const CONDITIONS_LEARN_DRAWING_TIPS = [
  "Draw the complete reaction (reactants and products) and perform 'exact' search.",
  'Omit stereochemistry (currently not supported).',
  'Avoid R-groups, generics, explicit hydrogens, atom mapping and inorganic reactions.',
];

export const CONDITIONS_LEARN_WHAT_YOU_WILL_SEE = [
  '<b>Reagents, catalysts, and solvents</b> used in similar reactions',
  '<b>Similar reactions and supporting references</b> to review and compare',
  '<b>Median yield</b> to help estimate likely outcomes',
  '<b>Functional group reactivity</b> under the identified conditions',
  '<b>Most commonly used reagents</b> across similar reactions',
  '<b>Export results</b> to share with colleagues',
];

// Ready-made reaction SMILES offered in the same panel. Clicking one loads it straight into
// whichever editor the draw page currently hosts (MarvinJS or ChemDrawJS), so the strings must
// stay valid reaction SMILES — both editors parse them natively.
export const CONDITIONS_DRAW_EXAMPLES = [
  {
    key: 'suzuki-coupling',
    label: 'Suzuki coupling',
    smiles: 'ClC1=CN=CC=C1.COC1=CC=C(C=C1)B(O)O>>COC1=CC=C(C=C1)C1=CN=CC=C1',
  },
  {
    key: 'nazarov-cyclisation',
    label: 'Nazarov cyclisation',
    smiles:
      'COC1=CC=C(C=C(C(=O)C2=CC(OC)=CC(OC)=C2)C2=CC(OC)=CC(OC)=C2)C=C1>>COC1=CC=C(C=C1)C1C(C(=O)C2=CC(OC)=CC(OC)=C12)C1=CC(OC)=CC(OC)=C1',
  },
];

export const CONDITIONS_EXPORT_TEMPLATE = 'ConditionsNavigator';
export const CONDITIONS_EXPORT_FORMATS_TOOLTIP =
  'Select an export format that is most suitable for you e.g. PDF, Microsoft Word, Microsoft Excel or CSV.<br /> Exported Reaxys data is subject to our <a href="https://www.elsevier.support/reaxys/answer/how-can-exported-data-from-reaxys-be-used" target="_blank">Terms & Conditions</a> on authorized use.';
export const CONDITIONS_EXPORT_FORMATS = [
  { label: 'PDF', value: 'PDF', additional_options: [] },
  { label: 'Microsoft Excel (.xlsx)', value: 'MSEXCEL', additional_options: [] },
  { label: 'CSV', value: 'CSVTABS', additional_options: [] },
  { label: 'Microsoft Word', value: 'MSWORD', additional_options: [] },
];
export const CONDITIONS_EXPORT_SORT_FIELD = {
  rank: 'rank',
  yieldPercent: 'medianYield',
  reactionCount: 'reactionCount',
};

export const CONDITIONS_FETCH_PROJECTS = 'conditions/FETCH_PROJECTS';
export const CONDITIONS_FETCH_PROJECTS_SUCCESS = 'conditions/FETCH_PROJECTS_SUCCESS';
export const CONDITIONS_FETCH_PROJECTS_FAILURE = 'conditions/FETCH_PROJECTS_FAILURE';
export const CONDITIONS_SET_SORT = 'conditions/SET_SORT';
export const CONDITIONS_SET_PAGING = 'conditions/SET_PAGING';
export const CONDITIONS_SET_SELECTED_IDS = 'conditions/SET_SELECTED_IDS';
export const CONDITIONS_SET_ANNOUNCEMENT = 'conditions/SET_ANNOUNCEMENT';
export const CONDITIONS_RESET_NAVIGATOR_VIEW = 'conditions/RESET_NAVIGATOR_VIEW';
export const CONDITIONS_RENAME_PROJECT = 'conditions/RENAME_PROJECT';
export const CONDITIONS_RENAME_PROJECT_SUCCESS = 'conditions/RENAME_PROJECT_SUCCESS';
export const CONDITIONS_RENAME_PROJECT_FAILURE = 'conditions/RENAME_PROJECT_FAILURE';
export const CONDITIONS_DELETE_PROJECTS = 'conditions/DELETE_PROJECTS';
export const CONDITIONS_DELETE_PROJECTS_SUCCESS = 'conditions/DELETE_PROJECTS_SUCCESS';
export const CONDITIONS_DELETE_PROJECTS_FAILURE = 'conditions/DELETE_PROJECTS_FAILURE';
export const CONDITIONS_FETCH_DETAIL = 'conditions/FETCH_DETAIL';
export const CONDITIONS_SELECT_DETAIL = 'conditions/SELECT_DETAIL';
export const CONDITIONS_FETCH_DETAIL_SUCCESS = 'conditions/FETCH_DETAIL_SUCCESS';
export const CONDITIONS_FETCH_DETAIL_FAILURE = 'conditions/FETCH_DETAIL_FAILURE';
export const CONDITIONS_SET_DETAIL_SORT = 'conditions/SET_DETAIL_SORT';
export const CONDITIONS_SET_DETAIL_CONDITION_SET_COUNT = 'conditions/SET_DETAIL_CONDITION_SET_COUNT';
export const CONDITIONS_SET_DETAIL_FUNCTIONAL_GROUPS_EXPANDED = 'conditions/SET_DETAIL_FUNCTIONAL_GROUPS_EXPANDED';
export const CONDITIONS_SET_DETAIL_SUMMARY_TAB = 'conditions/SET_DETAIL_SUMMARY_TAB';
export const CONDITIONS_SET_NAVIGATOR_RESTORATION = 'conditions/SET_NAVIGATOR_RESTORATION';
export const CONDITIONS_CONSUME_NAVIGATOR_RESTORATION = 'conditions/CONSUME_NAVIGATOR_RESTORATION';
export const CONDITIONS_SET_DETAIL_RESTORATION = 'conditions/SET_DETAIL_RESTORATION';
export const CONDITIONS_CONSUME_DETAIL_RESTORATION = 'conditions/CONSUME_DETAIL_RESTORATION';
